import { render, staticRenderFns } from "./menuSecond.vue?vue&type=template&id=ceee6f92&scoped=true"
import script from "./menuSecond.vue?vue&type=script&lang=js"
export * from "./menuSecond.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceee6f92",
  null
  
)

export default component.exports